// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GdX_355XU4ZKop {
  display: block;
  max-width: 100%;
  height: auto;
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  margin: 18px auto 42px auto;
}
.mkAua9Q8fCTcEM {
  margin-top: var(--ds-space-500, 40px);
  color: var(--ds-text, #172b4d);
  font-size: 24px;
  letter-spacing: -0.01em;
  line-height: 28px;
  font-weight: var(--ds-font-weight-semibold, 600);
  margin-top: var(--ds-space-0, 0);
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  margin-bottom: 10px;
}
.T8j15vWsulLcou {
  margin-bottom: 8px;
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  padding: 16px;
  background-color: var(--ds-background-neutral, #091e420f);
  color: var(--ds-text-subtle, #44546f);
  font-size: 14px;
  line-height: 18px;
  white-space: pre-line;
}
.T8j15vWsulLcou a {
  color: var(--ds-link, #0c66e4);
  text-decoration: none;
}
.T8j15vWsulLcou a:hover,
.T8j15vWsulLcou a:active {
  text-decoration: underline;
}
.TWn98V1Jr9fNyl {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 530px;
  margin: auto;
}
.TWn98V1Jr9fNyl .DAlSQcdYjddT3r {
  color: var(--ds-text-danger, #ae2a19);
  font-size: 14px;
}
.TWn98V1Jr9fNyl .MwSELFXjguONZb {
  margin-top: 28px;
  color: var(--ds-text, #172b4d);
  font-size: 20px;
  letter-spacing: -0.008em;
  line-height: 24px;
  font-weight: var(--ds-font-weight-semibold, 600);
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  margin-top: 40px;
  font-weight: var(--ds-font-weight-medium, 500);
  line-height: 26px;
}
.TWn98V1Jr9fNyl hr {
  margin-top: var(--ds-space-0, 0);
  /* 16px pixel gap but -1px for the height of the HR */
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  margin-bottom: 15px;
}
.TWn98V1Jr9fNyl .rNrK73oYijEo4Z {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: var(--ds-space-0, 0);
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  margin-bottom: 12px;
}
.TWn98V1Jr9fNyl .rNrK73oYijEo4Z .uTIHO3GzfdDfUx {
  margin-top: var(--ds-space-200, 16px);
  color: var(--ds-text, #172b4d);
  font-size: 14px;
  letter-spacing: -0.003em;
  line-height: 16px;
  font-weight: var(--ds-font-weight-semibold, 600);
  margin-top: var(--ds-space-0, 0);
  margin-bottom: var(--ds-space-0, 0);
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  padding-top: 16px;
}
.TWn98V1Jr9fNyl .rNrK73oYijEo4Z .BhKpPksZzSG251 {
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  padding-top: 16px;
}
.TWn98V1Jr9fNyl .lLPOcckrFfwys7 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-block-start: 8px;
}
.TWn98V1Jr9fNyl .lLPOcckrFfwys7 .cwNe5VAI66iHYX {
  display: flex;
  flex: 0 0 100%;
  flex-direction: column;
}
@media only screen and (max-width: 750px) {
  .TWn98V1Jr9fNyl .lLPOcckrFfwys7 .cwNe5VAI66iHYX {
    flex: 1;
  }
}
.TWn98V1Jr9fNyl .lLPOcckrFfwys7 .JhBc38JIAKzHAt {
  width: fit-content;
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  margin-top: 40px;
  margin-right: var(--ds-space-0, 0);
  margin-left: auto;
}
.TWn98V1Jr9fNyl .lLPOcckrFfwys7 .tH2A__DcRdqCIx {
  color: var(--ds-text, #172b4d);
  font: var(--ds-font-body, 400 14px / 20px -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Noto Sans', 'Ubuntu', 'Droid Sans', 'Helvetica Neue', sans-serif);
  font-display: swap;
  padding: 8px 12px;
  border-radius: 3px;
  transition-property: background-color, border-color, box-shadow;
  transition-duration: 85ms;
  transition-timing-function: ease;
  box-sizing: border-box;
  border: none;
  outline: none;
  background-color: var(--ds-background-input, #ffffff);
  box-shadow: inset 0 0 0 1px var(--ds-border-input, #091e4224);
  height: 72px;
  margin-bottom: 8px;
  color: var(--ds-text-subtle, #44546f);
  resize: vertical;
}
.TWn98V1Jr9fNyl .lLPOcckrFfwys7 .tH2A__DcRdqCIx:hover {
  background-color: var(--ds-background-input-hovered, #f7f8f9);
  box-shadow: inset 0 0 0 1px var(--ds-border-input, #091e4224);
}
.TWn98V1Jr9fNyl .lLPOcckrFfwys7 .tH2A__DcRdqCIx:focus {
  background-color: var(--ds-background-input, #ffffff);
  box-shadow: inset 0 0 0 2px var(--ds-border-focused, #388bff);
}
.TWn98V1Jr9fNyl .lLPOcckrFfwys7 .tH2A__DcRdqCIx:disabled {
  background-color: var(--ds-background-disabled, #091e4208);
  box-shadow: none;
  color: var(--ds-text-disabled, #091e424f);
  cursor: not-allowed;
  -webkit-user-select: none;
          user-select: none;
}
.TWn98V1Jr9fNyl .lLPOcckrFfwys7 .tH2A__DcRdqCIx[readonly] {
  background-color: var(--ds-background-disabled, #091e4208);
  box-shadow: inset 0 0 0 2px var(--ds-border-input, #091e4224);
}
.TWn98V1Jr9fNyl .lLPOcckrFfwys7 .tH2A__DcRdqCIx.BhwLAXmDVO9TnA {
  box-shadow: inset 0 0 0 1px var(--ds-border-danger, #e34935);
}
.TWn98V1Jr9fNyl .lLPOcckrFfwys7 .tH2A__DcRdqCIx.BhwLAXmDVO9TnA:hover {
  box-shadow: inset 0 0 0 1px var(--ds-border-danger, #e34935);
}
.TWn98V1Jr9fNyl .lLPOcckrFfwys7 .tH2A__DcRdqCIx.BhwLAXmDVO9TnA:focus {
  box-shadow: inset 0 0 0 1px var(--ds-border-danger, #e34935);
}
.TWn98V1Jr9fNyl .lLPOcckrFfwys7 .tH2A__DcRdqCIx.Re7aofJCgirP5s {
  width: 100%;
}
.TWn98V1Jr9fNyl .lLPOcckrFfwys7 .tH2A__DcRdqCIx::placeholder {
  color: var(--ds-text-subtlest, #626f86);
}
.TWn98V1Jr9fNyl .lLPOcckrFfwys7 .tH2A__DcRdqCIx:hover {
  background: var(--ds-background-input, #ffffff);
}
.TWn98V1Jr9fNyl .lLPOcckrFfwys7 .tH2A__DcRdqCIx:focus {
  color: var(--ds-text, #172b4d);
}
.TWn98V1Jr9fNyl .F5h6BDQVMy8aMF {
  margin-bottom: var(--ds-space-200, 16px);
}
.j02j_tj1MYmFeT {
  padding-inline-start: var(--ds-space-025, 2px);
  color: var(--ds-text-danger, #de350b);
}
@media screen and (max-width: 530px) {
  .TWn98V1Jr9fNyl .lLPOcckrFfwys7 {
    flex-direction: column;
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tacoPrivacy": `GdX_355XU4ZKop`,
	"profileHeader": `mkAua9Q8fCTcEM`,
	"legalText": `T8j15vWsulLcou`,
	"memberProfileTabContainer": `TWn98V1Jr9fNyl`,
	"error": `DAlSQcdYjddT3r`,
	"sectionHeader": `MwSELFXjguONZb`,
	"inputLabel": `rNrK73oYijEo4Z`,
	"text": `uTIHO3GzfdDfUx`,
	"privacyLabel": `BhKpPksZzSG251`,
	"aboutContent": `lLPOcckrFfwys7`,
	"leftColumn": `cwNe5VAI66iHYX`,
	"profileSaveButton": `JhBc38JIAKzHAt`,
	"bioTextArea": `tH2A__DcRdqCIx`,
	"input-error": `BhwLAXmDVO9TnA`,
	"full": `Re7aofJCgirP5s`,
	"profileSyncSectionMessage": `F5h6BDQVMy8aMF`,
	"requiredAsterisk": `j02j_tj1MYmFeT`
};
export default ___CSS_LOADER_EXPORT___;
